import { useEffect, useRef } from "react";

import useCheckDevice from "@repo/shopify/hooks/useCheckDevice";

export default function useHeaderScroll() {
  const { isPC } = useCheckDevice();
  const lastScrollTop = useRef(0);

  useEffect(() => {
    if (isPC) return;

    const header = document.getElementById("header");
    const filter = document.getElementById("filter");

    if (!header || !filter) return;

    // 1. 초기 트랜지션 설정 (스크롤 이벤트 밖으로 빼서 성능 최적화)
    header.style.transition = "top 0.3s ease-in-out";
    filter.style.transition = "top 0.3s ease-in-out";

    lastScrollTop.current = window.scrollY || document.documentElement.scrollTop;

    const handleScroll = () => {
      const currentScroll = window.scrollY || document.documentElement.scrollTop;
      const { top } = filter.getBoundingClientRect();

      // 2. [핵심] 스크롤이 맨 위(0 이하)일 때는 무조건 헤더와 필터 원복 (iOS 바운스 고려)
      if (currentScroll <= 0) {
        header.style.top = "0px";
        filter.style.top = "52px";
        lastScrollTop.current = 0;
        return;
      }

      if (currentScroll > lastScrollTop.current) {
        // 3. 스크롤 내릴 때 (Scrolling DOWN)
        if (top <= 52) {
          header.style.top = "-52px";
          filter.style.top = "0px";
        } else {
          header.style.top = "0px";
          filter.style.top = "52px";
        }
      } else {
        // 4. 스크롤 올릴 때 (Scrolling UP) - 조건 없이 무조건 노출
        header.style.top = "0px";
        filter.style.top = "52px";
      }

      // 5. 스크롤 위치 업데이트
      lastScrollTop.current = currentScroll;
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);

    // 6. 클린업 함수
    return () => {
      if (header) {
        header.style.transition = "";
        header.style.top = "0px";
      }
      if (filter) {
        filter.style.transition = "";
        filter.style.top = "52px"; // 필터의 원래 위치로 초기화
      }
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isPC]);
}
